// IMP START - Quick Start
import { WEB3AUTH_NETWORK } from '@web3auth/modal';
import { type Web3AuthContextConfig } from '@web3auth/modal/react';
// IMP END - Quick Start

// IMP START - Dashboard Registration
const clientId = process.env.REACT_APP_WEB3_AUTH_CLIENT_ID!;

// IMP END - Dashboard Registration

// IMP START - Config
const web3AuthContextConfig: Web3AuthContextConfig = {
  web3AuthOptions: {
    clientId,
    web3AuthNetwork:
      process.env.NODE_ENV === 'development' ? WEB3AUTH_NETWORK.SAPPHIRE_DEVNET : WEB3AUTH_NETWORK.SAPPHIRE_MAINNET,
    // uiConfig: {
    //   logoLight: ASSETFI_LOGO, // 'https://yourdomain.com/logo.png',
    //   logoDark: ASSETFI_LOGO, // 'https://yourdomain.com/logo.png',
    // },
    // uiConfig: {
    //   loginMethodsOrder: ['google', 'facebook'], // 원하는 로그인 순서
    //   logoLight: 'https://yourdomain.com/logo.png', // appLogo 대신 logoLight 사용
    //   logoDark: 'https://yourdomain.com/logo.png', // dark 모드 로고도 지정
    //   defaultLanguage: 'ko', // 기본 언어
    // },
    // 예시: theme: WHITE_LABEL_THEME.LIGHT
  },
};
// IMP END - Config

export default web3AuthContextConfig;
